<template>
  <div>
    <!--title start-->
    <div id="printtitle">
      <!-- menu title -->
      <div class="grab">
        <div class="tit_nav">
          <h4>{{ $t("researchperform") }}</h4>
        </div>
        <ul id="myTab" class="depth_3" >
          <li role="presentation" v-bind:class="{active:tabIndex==0}" style="width: 33.3%">
            <a v-on:click="tabIndex=0" id="tab0-btn" role="tab" data-toggle="tab"
                                                                         aria-expanded="true">{{ $t("researchfield_title_1") }}</a>
          </li>
          <li role="presentation" v-bind:class="{active:tabIndex==1}" style="width: 33.3%">
            <a v-on:click="tabIndex=1" id="tab1-tab" role="tab" data-toggle="tab"
                                                                         aria-expanded="false">{{ $t("researchfield_title_2") }} </a>
          </li>
          <li role="presentation" v-bind:class="{active:tabIndex==2}" style="width: 33.3%">
            <a v-on:click="tabIndex=2" id="tab2-tab" role="tab" data-toggle="tab"
                                                                         aria-expanded="false">{{ $t("researchfield_title_3") }} </a>
          </li>
        </ul>
      </div>
    </div>

    <!--content start-->
    <div id="study-perform" class="grab h4wrap">
      <!--part1-->
      <div class="tab-pane">
        <!--list star-->
        <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
          <!--list1-->
          <div class="panel" v-for="(item,index) in board" v-if="tabIndex==(item.category-1)%3">
            <div class="panel-heading" role="tab" id="headingOne">
              <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne" v-on:click="expIndex1=index">
                {{item.title}}
              </a>
              <span class="glyphicon glyphicon-menu-down"></span>
              <p class="admin-button-group" v-if="login_state">
                <button class="edit-button" v-if="login_state" v-on:click="editItem(item.no)">{{ $t("edit") }}</button>
                <button class="del-button" v-if="login_state" v-on:click="deleteItem(item.no)">{{ $t("delete") }}</button></p>
            </div>
            <div id="collapseOne" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingOne" v-bind:class="{in:index==expIndex1}">
              <div class="panel-body">
                {{item.contents}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <button v-if="login_state" v-on:click="addItem()">{{ $t("add") }} </button>
    </div>
  </div>
</template>

<script>

  import api from '../api/api'
  import { mapState } from 'vuex'
  import Constant from '../constant'
  import axios from 'axios'

  export default {
    name: 'ResearchPerform',
    data: function () {
      return {
        tabIndex:0,
        expIndex1:0,
        expIndex2:0,
        board: [
          {
            no : 2,
            category:1,
            title : '수도권 빌딩숲 기상장의 매개변수화 및 빌딩숲 규모 3차원 입체 관측 수행',
            contents : "간단한 상세 내용이 나온다.3"
          },
          {
            no : 3,
            category:1,
            title : '관측기반 대기질 모델 개선체계 구축(III)',
            contents : "간단한 상세 내용이 나온다.4"},
          {
            no : 6,
            category:2,
            title : '수도권 빌딩숲 기상장asdfasdf딩숲 규모 3차원 입체 관측 수행',
            contents : "간단한 상세 내용이 나온다.3"
          },
          {
            no : 7,
            category:9,
            title : '관측기반 대기질 asdfasf체계 구축(III)',
            contents : "간단한 상세 내용이 나온다.4"},
          {
            no : 6,
            category:3,
            title : '33수도권 빌딩숲 기상장asdfasdf딩숲 규모 3차원 입체 관측 수행',
            contents : "간단한 상세 내용이 나온다.3"
          },
        ],
      }
    },
    computed: _.extend({
      test: function ()
      {
      }
    },mapState(['user_name' , 'login_state'])),
    created: function ()
    {
      console.log('## 12343')
      this.update()
    },
    methods : {
      editItem : function(no){
        console.log('xx edit ' + no)
        // Trigger an Alert dialog
        this.$router.push({name: "researchwrite" , params:{type:0,contentsNo:no} })
      },
      deleteItem: function(no) {
        console.log('xx delete ' + no)
        if (confirm( this.$t("message_delete")) ) {
          console.log("You pressed OK!");

          api.delete(no).then((response) => {
            if (response.data.status === 'success') {
              this.update()
            }
            else {
              console.log('## 3 ' + JSON.stringify(response.data));
              alert('에러 : ' + response.data.message)
            }
          })
        }
        else {
          console.log("You pressed Cancel!");
        }
      },
      addItem : function() {
        console.log('xx aa ')
        this.$router.push({name: "researchwrite" , params:{type:0,contentsNo:0} })

      },
      update : function() {
        console.log('## update')
        //this.$router.push({name: "researchwrite" , params:{type:0,contentsNo:0} })
        api.reqList(0 , '1,2,9' , -1 )
          .then((response) => {
            console.log('## 3 ' + JSON.stringify(response.data));
            console.log('## 32 ' + 'done')

            if (response.data.status === 'success') {
              this.board = response.data.items;
            }
            else {
              console.log('## 3 ' + JSON.stringify(response.data));
              alert('에러 : ' + response.data.message)
            }

          })

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ResearchPerform.vue